import React, { useContext, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import './UploadLists.sass'
import { AuthContext } from '../../../../../../context/AuthContext'
import Notify from '../../../../../Notify'
import useOutsideClick from '../../../../../../hooks/useOutsideClick'

function UploadListsCell(props) {
  const { token } = useContext(AuthContext)
  const { orgId } = useParams()
  const [type, setType] = useState(false)
  const [uploaded, setUploaded] = useState(props.cellContent[props.cellData.uploaded])
  const baseURL = process.env.REACT_APP_BASE_URL
  const [notify, setNotify] = useState()
  const myRef = useRef()
  
  useOutsideClick(myRef, () => {
    setNotify(null)
  })
const userId = useContext(AuthContext)?.token?.userId
  const sendList = async (formData) => {
    const url = `${baseURL}/api/v2/verificationCenters/${userId}/organizations/${orgId}/histories/${props.idArr[0]}`
    const ERROR_TEXT = `Ой! Что-то пошло не так. Повторите попытку позже.`

    try {
      await fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${token.token}`
        }
      }).then(async res => ({ status: res.status, body: await res.json() }))
        .then(res => {
          const message = res.body?.message


          message === 'ok'
            ? (function() {
               uploaded
                   ? setNotify('Список изменен!')
                   : setNotify(null)
              setUploaded(res?.body.data[0]?.document.uploaded)
            }())
            : setNotify(message || ERROR_TEXT)
        })

    } catch (e) {
      setNotify(ERROR_TEXT)
    }

  }

  function importData() {
    let formData = new FormData()
    let input = document.createElement('input')
    input.type = 'file'
    input.onchange = async _ => {
      const selectedFile = input.files
      formData.append(`doc`, selectedFile[0], selectedFile[0].name)
      await sendList(formData)

    }

    input.click()
  }

  return (
    <>
      <div style={{ overflow: 'inherit' }} key={props.api + type} className='row__cell'>
        <Notify notifyVisibility={notify}
                size='small'
                customStyles={{ maxWidth: '200px', whiteSpace: 'wrap' }}
                reff={myRef}
                horizontalDirection='right'
                notifyInner={notify}>

          <button onClick={importData} className='uploadList'>{uploaded ? 'Изменить' : 'Загрузить'}

          </button>
        </Notify>
      </div>
      {uploaded ?
        <div className='uploadStatus'>
          <i className='fas fa-check' />
        </div>
        : ''}
    </>
  )
}

export default UploadListsCell
